import React from 'react';


import './UploadList.css';


import UploadListNew from './UploadListNew';
import UploadListAmend from './UploadListAmend';



class UploadList extends React.Component{
constructor(props){
super(props)
  this.state = {
    uploadChoice:'',
  }
}

setChoice = (val) =>{

  this.setState({uploadChoice:val});
}



render(){


if(this.state.uploadChoice === 'new'){

return(

  <div style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100}}>
  <button className="br1 pa3 bg-blue br-blue" style={{width:100}} onClick={() => this.setChoice('none')}>Go back</button>
    <UploadListNew/>
  </div>
)

}

if(this.state.uploadChoice === 'amend'){

return(
  <div style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100}}>
  <button className="br1 pa3 bg-blue br-blue" style={{width:100}} onClick={() => this.setChoice('none')}>Go back</button>
  <UploadListAmend/>
  </div>
)

}


return(
  <div className="ma2 pa2 br3 shadow-4" style={{display:'flex', flexDirection:'column', justifyContent:'left', margin:100,backgroundColor:'white'}}>
<h2>Please select option to upload file</h2>
<div>
<button className="br3 pa3 bg-blue br-blue" onClick={() => this.setChoice('new')}>Upload New Set</button>


<button className="br3 pa3 bg-blue br-blue" onClick={() => this.setChoice('amend')}>Upload Amend Set</button>
</div>
</div>
)

}

}

export default UploadList;



// WEBPACK FOOTER //
// ./src/components/UploadList/UploadList.js